class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Talbinah: voortgangsbalk gratis verzending (vanaf EUR 30, NL & BE) */
(function () {
  var THRESHOLD = 3000;
  function fmt(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  var TXT = {
    nl: ['Nog <strong>{x}</strong> en je krijgt <strong>gratis verzending</strong> (NL &amp; BE)', '✓ Je bestelling wordt <strong>gratis verzonden</strong> (NL &amp; BE)'],
    en: ['Add <strong>{x}</strong> more for <strong>free shipping</strong> (NL &amp; BE)', '✓ Your order ships <strong>free</strong> (NL &amp; BE)'],
    de: ['Noch <strong>{x}</strong> bis zum <strong>kostenlosen Versand</strong> (NL &amp; BE)', '✓ Deine Bestellung wird <strong>kostenlos versendet</strong> (NL &amp; BE)'],
    ar: ['أضف <strong>{x}</strong> للحصول على <strong>شحن مجاني</strong> (هولندا وبلجيكا)', '✓ سيتم شحن طلبك <strong>مجانًا</strong> (هولندا وبلجيكا)']
  };
  function lang() { var l = (document.documentElement.lang || 'nl').toLowerCase().slice(0, 2); return TXT[l] ? l : 'nl'; }
  function render(cart) {
    var footer = document.querySelector('cart-drawer .drawer__footer');
    if (!footer) return;
    var el = footer.querySelector('.tb-freeship');
    if (!el) {
      el = document.createElement('div');
      el.className = 'tb-freeship';
      el.setAttribute('role', 'status');
      footer.insertBefore(el, footer.firstChild);
    }
    if (!cart || !cart.item_count) { el.style.display = 'none'; return; }
    el.style.display = '';
    var left = THRESHOLD - cart.total_price;
    var pct = Math.max(0, Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100)));
    var t = TXT[lang()];
    var msg = left > 0 ? t[0].replace('{x}', fmt(left)) : t[1];
    el.innerHTML = '<p class="tb-freeship__text">' + msg + '</p><div class="tb-freeship__track"><span style="width:' + pct + '%"></span></div>';
  }
  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    var base = (window.routes && window.routes.cart_url) || '/cart';
    fetch(base + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { busy = false; render(cart); })
      .catch(function () { busy = false; });
  }
  var css = document.createElement('style');
  css.textContent = '.tb-freeship{margin:0 0 1.2rem;font-size:1.4rem;line-height:1.4}' +
    '.tb-freeship__text{margin:0 0 .6rem}' +
    '.tb-freeship__track{height:6px;border-radius:3px;background:rgba(var(--color-foreground),.12);overflow:hidden}' +
    '.tb-freeship__track span{display:block;height:100%;background:rgb(var(--color-button));transition:width .3s ease}';
  document.head.appendChild(css);
  var observer = new MutationObserver(function () {
    var f = document.querySelector('cart-drawer .drawer__footer');
    if (f && !f.querySelector('.tb-freeship')) refresh();
  });
  function init() {
    var d = document.querySelector('cart-drawer');
    if (d) observer.observe(d, { childList: true, subtree: true });
    refresh();
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 100); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
